import * as React from "react";

const IconPlus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      d="M12.501 7.501H9V4a1 1 0 0 0-2 0v3.501H3.501a1 1 0 0 0 0 2H7V13a1 1 0 1 0 2 0V9.501h3.501a1 1 0 0 0 0-2Z"
      fill="#4F4FFF"
    />
  </svg>
);

export default IconPlus;
